export default __webpack_public_path__ + "static/media/FullSceneAfternoonBaked.c7ea2e48.glb";